import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requirePostcss } from "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss2.js";
var postcssExports = requirePostcss();
const postcss = /* @__PURE__ */ getDefaultExportFromCjs(postcssExports);
export {
  postcss as default
};
//# sourceMappingURL=postcss.js.map
